import { render, staticRenderFns } from "./uploadList.vue?vue&type=template&id=f161ba90&scoped=true&"
import script from "./uploadList.vue?vue&type=script&lang=js&"
export * from "./uploadList.vue?vue&type=script&lang=js&"
import style0 from "./uploadList.vue?vue&type=style&index=0&id=f161ba90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f161ba90",
  null
  
)

component.options.__file = "uploadList.vue"
export default component.exports